class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.addEventListener("click", (event) => {
      event.preventDefault();
      if (!this.cartDrawer.loading) {
        this.cartDrawer.setLoading();
        const cartItems =
          this.closest("cart-items") || this.closest("cart-drawer-items");
        const item = this.closest(".cart-item");
        if (item.getAttribute("data-giftwrap")) {
          // remove gift wrap
          cartItems.updateQuantity(this.dataset.index, 0, undefined, {
            note: "",
          });
        } else if (item.getAttribute("data-bundle-name")) {
          let bundleID = item.getAttribute("data-bundle-id");
          let bundleParts = cartItems.querySelectorAll(
            `[data-bundle-part-id="${bundleID}"]`
          );
          let ItemBundleIds = [];
          this.closest(".cart-item")
            .querySelector(".loading-overlay")
            .classList.remove("hidden");
          bundleParts.forEach((part) => {
            ItemBundleIds.push(part.dataset.lineItemId);
          });

          // remove bundle
          cartItems.removeBundle(ItemBundleIds);
        } else {
          // remove item
          cartItems.updateQuantity(this.dataset.index, 0);
        }
        this.cartDrawer.setNotLoading();
      }
    });
  }

  sendTrackingEvent(quantity, itemIndex) {
    const cartItem = JSON.parse(
      this.closest(".cart-item").querySelector("#tracking-data").content
        .textContent
    );
    const trackingData = {
      event: "remove_from_cart",
      ecommerce: {
        currency: cartItem.currency,
        value:
          cartItem.discount != null
            ? (parseFloat(cartItem.price) - parseFloat(cartItem.discount)) *
              parseInt(quantity)
            : parseFloat(cartItem.price) * parseInt(quantity),
        items: [
          {
            item_id: cartItem.item_id,
            item_name: cartItem.item_name,
            affiliation: "Victoria Beckham Beauty",
            currency: cartItem.currency,
            ...(cartItem.discount && {
              discount: parseFloat(cartItem.discount),
            }),
            ...(cartItem.coupon && {
              coupon: cartItem.coupon,
            }),
            index: parseInt(itemIndex),
            item_brand: "Victoria Beckham Beauty",
            ...(cartItem.item_variant != null && {
              item_variant: cartItem.item_variant,
            }),
            price: parseFloat(cartItem.price),
            quantity: parseInt(quantity),
          },
        ],
      },
    };
    window.Shopify.analytics.publish(
      "custom_product_remove_from_cart",
      trackingData
    );
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.ran = 0;
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");
    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
    this.handleGWP();
    this.updateShippingMessage();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  updateShippingMessage() {
    let pdpMessage = document.querySelector(
      ".vbb-product-details__buybox .cart-message"
    );
    if (pdpMessage) {
      let message = document.querySelector("cart-drawer .cart-message");
      // Its adding <br> tags for some reason so this replace fixes it. There are none in the cart message
      // so not sure where they are coming from
      pdpMessage.innerText = message.textContent.replace(/[\n\r]/g, " ");
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  onCartUpdate() {
    fetch(`${window.Shopify.routes.root}cart?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const cartItem = html.querySelector("cart-items");
        this.innerHTML = cartItem.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  // GWP Threshold
  updateGwp() {
    this.cartDrawer.setLoading();

    const getCartTotal = async () => {
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
          method: "GET",
          headers: {
            "content-type": "application/json",
          },
        });
        const cart = await response.json();
        return cart;
      } catch (error) {
        console.error("Error fetching cart total:", error);
      }
    };

    // Call the getCartTotal function if GWP is enabled
    if (window.vbbGiftWithPurchase && window.vbbGiftWithPurchase.enabled) {
      (async () => {
        const cart = await getCartTotal();

        // Convert the cart total to a decimal format
        const totalPrice = cart.total_price / 100;
        const gwpInCart = cart.items.some((item) =>
          item.properties?.hasOwnProperty("_gwp-item")
        );

        // If the cart total is greater than the threshold and the GWP is not in the cart, add the GWP
        if (
          window.vbbGiftWithPurchase.autoAdd &&
          totalPrice >= window.vbbGiftWithPurchase.threshold &&
          !gwpInCart
        ) {
          this.addGwp(cart);
        }

        // If the cart total is less than the threshold and the GWP is in the cart, remove the GWP
        else if (
          totalPrice < window.vbbGiftWithPurchase.threshold &&
          gwpInCart
        ) {
          this.removeGwp();
        } else {
          this.cartDrawer.setNotLoading();
        }
      })();
    } else if (
      (!window.vbbGiftWithPurchase ||
        window.vbbGiftWithPurchase.enabled === false) &&
      document.querySelector(`[data-is-gwp="true"]`)
    ) {
      this.removeGwp();
    } else {
      this.cartDrawer.setNotLoading();
    }
  }

  async handleGWP() {
    await this.updateGwp();
    await this.handleGwpBuyXGetY();
  }

  addGwp() {
    const sections = this.cartDrawer
      .getSectionsToRender()
      .map((section) => section.id);
    const itemsToAdd = window.vbbGiftWithPurchase.items.map((item) => ({
      id: item,
      quantity: 1,
      properties: {
        "_gwp-item": "_gwp-item",
      },
    }));

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        items: itemsToAdd,
        sections: sections.join(","),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        // Update cart display to show the newly added product
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart",
        });
        this.cartDrawer.renderContents(response);
        this.cartDrawer.setNotLoading();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  removeGwp() {
    // Finds the GWP in the cart and triggers a click on the remove button
    const gwpCartItem = document.querySelector(`[data-is-gwp="true"]`);
    this.cartDrawer.setNotLoading();
    gwpCartItem.querySelector("cart-remove-button").click();
  }

  // Buy X get Y
  get cartItems() {
    return Array.from(document.querySelectorAll("tr[id^=CartDrawer-Item-]"));
  }

  get cartBundleItems() {
    return Array.from(
      document.querySelectorAll("tr[id^=CartDrawer-Item-Bundle-]")
    );
  }

  get cartItemsVariantIds() {
    return this.cartItems.map((item) => parseInt(item.dataset.variantId));
  }

  get cartItemsExcludingNonEligibles() {
    return this.cartItems.filter((item) => {
      return (
        !item.dataset.hasOwnProperty("isGwp") &&
        !item.dataset.hasOwnProperty("isBuyXGetYItem") &&
        !item.dataset.hasOwnProperty("bundlePartId") &&
        !item.dataset.hasOwnProperty("giftwrap")
      );
    });
  }

  get cartItemsExcludingNonEligiblesVariantIds() {
    return this.cartItemsExcludingNonEligibles.map((item) =>
      parseInt(item.dataset.variantId)
    );
  }
  get containsBuyXVariant() {
    if (this.cartDrawer.dataset.hasOwnProperty("buyXSetSlug")) {
      for (const cartItem of this.cartBundleItems) {
        if (
          cartItem.dataset.bundleSlug === this.cartDrawer.dataset.buyXSetSlug
        ) {
          return true;
        }
      }
    }

    for (const variantId of this.cartItemsExcludingNonEligiblesVariantIds) {
      if (
        window.vbbBuyXGetY &&
        window.vbbBuyXGetY.buyXVariantIds &&
        window.vbbBuyXGetY.buyXVariantIds.some((id) => id === variantId)
      ) {
        return true;
      }
    }

    return false;
  }

  get containsGetYVariant() {
    return this.cartItems.some((cartItem) => {
      return (
        cartItem.dataset.hasOwnProperty("isBuyXGetYItem") &&
        cartItem.dataset.isBuyXGetYItem === "true" &&
        parseInt(cartItem.dataset.variantId) ===
          window.vbbBuyXGetY.getYVariantId
      );
    });
  }
  async handleGwpBuyXGetY() {
    if (window.vbbBuyXGetY?.enabled === false) {
      const getYVariant =
        document.querySelector(`[data-is-buy-x-get-y-item="true"]`) ?? false;

      if (getYVariant) {
        const gwpCartItem = document.querySelector(
          `[data-is-buy-x-get-y-item="true"]`
        );
        this.cartDrawer.setNotLoading();
        gwpCartItem.querySelector("cart-remove-button").click();
      }
    }

    if (!this.containsBuyXVariant && this.containsGetYVariant) {
      const getYVariant = document.querySelector(
        `[data-is-buy-x-get-y-item="true"]`
      );

      if (getYVariant) {
        const gwpCartItem = document.querySelector(
          `[data-is-buy-x-get-y-item="true"]`
        );
        this.cartDrawer.setNotLoading();
        gwpCartItem.querySelector("cart-remove-button").click();
      }

      return;
    }

    if (this.containsBuyXVariant && !this.containsGetYVariant) {
      this.cartDrawer.setLoading();

      const sections = this.cartDrawer
        .getSectionsToRender()
        .map((section) => section.id);
      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          id: window.vbbBuyXGetY.getYVariantId,
          quantity: 1,
          properties: {
            "_buyxgety-item": "_buyxgety-item",
          },
          sections: sections.join(","),
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart" });
          this.cartDrawer.renderContents(response);
        })
        .catch((error) => console.error(error))
        .finally(() => this.cartDrawer.setNotLoading());
    }
  }
  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name, note) {
    const updatedCartItem = this.cartDrawer.querySelector(
      `#CartDrawer-Item-${line}`
    );

    this.enableLoading(line);

    if (quantity > updatedCartItem.dataset.quantity) {
      this.sendTrackingEvent(
        updatedCartItem,
        quantity - updatedCartItem.dataset.quantity,
        line,
        "add_to_cart"
      );
    } else {
      this.sendTrackingEvent(
        updatedCartItem,
        updatedCartItem.dataset.quantity - quantity,
        line,
        "remove_from_cart"
      );
    }
    this.cartDrawer.setLoading();
    const body = JSON.stringify({
      ...(note && note),
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        const parsedBundles = [];

        parsedState.item_count = parsedState.items.reduce((acc, curr) => {
          if (Object.keys(curr.properties).includes("_bundleId")) {
            const bundleId = curr.properties._bundleId;

            if (parsedBundles.includes(bundleId)) {
              return acc;
            } else {
              parsedBundles.push(bundleId);
            }
          }

          return acc + 1;
        }, 0);

        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedItem = parsedState.items[parseInt(line) - 1];

        if (parseInt(quantity) !== 0 && updatedItem) {
          const updatedValue = parsedState.items[parseInt(line) - 1].quantity;
          if (quantityElement && quantityElement.value) {
            const message =
              updatedValue !== parseInt(quantityElement.value)
                ? window.cartStrings.quantityError.replace(
                    "[quantity]",
                    updatedValue
                  )
                : "";

            this.updateLiveRegions(line, message);
          }
        }

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;

        // Reset the quantity input to the previous value
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);

        if (quantityElement) {
          quantityElement.value = updatedCartItem.dataset.quantity;
        }
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }
  removeMultipleItemsFromCart(lineItemIds) {
    const updates = {};
    lineItemIds.forEach(function (lineItemId) {
      updates[lineItemId] = 0;
    });

    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      ...fetchConfig(),
      body: JSON.stringify({
        updates,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        const parsedBundles = [];

        parsedState.item_count = parsedState.items.reduce((acc, curr) => {
          if (Object.keys(curr.properties).includes("_bundleId")) {
            const bundleId = curr.properties._bundleId;

            if (parsedBundles.includes(bundleId)) {
              return acc;
            } else {
              parsedBundles.push(bundleId);
            }
          }

          return acc + 1;
        }, 0);

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch((error) => {
        console.log(error);
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.cartDrawer.setNotLoading();
      });
    this.sendTrackingEventMulti(lineItemIds);
  }
  removeBundle(itemsIds) {
    this.removeMultipleItemsFromCart(itemsIds);
  }
  sendTrackingEventMulti(items) {
    let cartItems = items.map((item, index) => {
      const cartItem = this.cartDrawer.querySelector(
        `tr[data-line-item-id="${item}"]`
      );
      const data = JSON.parse(
        cartItem.querySelector("#tracking-data").content.textContent
      );

      return {
        item_id: data.item_id,
        item_name: data.item_name,
        affiliation: "Victoria Beckham Beauty",
        currency: data.currency,
        ...(data.discount && {
          discount: parseFloat(data.discount),
        }),
        ...(data.coupon && {
          coupon: data.coupon,
        }),
        index,
        item_brand: "Victoria Beckham Beauty",
        ...(data.item_variant != null && {
          item_variant: data.item_variant,
        }),
        price: parseFloat(data.price),
        quantity: parseInt(data.quantity),
      };
    });
    const trackingData = {
      event: "remove_from_cart",
      ecommerce: {
        currency: cartItems[0].currency,
        items: [...cartItems],
      },
    };
    trackingData.ecommerce.value = trackingData.ecommerce.items.reduce(
      (total, item) => {
        return total + item.price * item.quantity;
      },
      0
    );
    window.Shopify.analytics.publish(
      `custom_product_remove_from_cart`,
      trackingData
    );
  }
  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    const element = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
    if (element) {
      return element.innerHTML;
    }

    return;
  }
  sendTrackingEvent(item, quantity, itemIndex, eventName) {
    const cartItem = JSON.parse(
      item.querySelector("#tracking-data").content.textContent
    );
    const trackingData = {
      event: eventName,
      ecommerce: {
        currency: cartItem.currency,
        value:
          cartItem.discount != null
            ? (parseFloat(cartItem.price) - parseFloat(cartItem.discount)) *
              parseInt(quantity)
            : parseFloat(cartItem.price) * parseInt(quantity),
        items: [
          {
            item_id: cartItem.item_id,
            item_name: cartItem.item_name,
            affiliation: "Victoria Beckham Beauty",
            currency: cartItem.currency,
            ...(cartItem.discount && {
              discount: parseFloat(cartItem.discount),
            }),
            ...(cartItem.coupon && {
              coupon: cartItem.coupon,
            }),
            index: parseInt(itemIndex),
            item_brand: "Victoria Beckham Beauty",
            ...(cartItem.item_variant != null && {
              item_variant: cartItem.item_variant,
            }),
            price: parseFloat(cartItem.price),
            quantity: parseInt(quantity),
          },
        ],
      },
    };
    window.Shopify.analytics.publish(
      `custom_product_${eventName}`,
      trackingData
    );
  }
  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    if (mainCartItems) {
      mainCartItems.classList.remove("cart__items--disabled");
    }

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );

    this.cartDrawer.setNotLoading();
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
